<ng-container *transloco="let t" class="container">
  <div class="modal-body">
    <div class="d-flex align-items-center pb-4">
      <div class="logo-wrapper">
        <img src="../../../assets/img/svg/T-alt.svg" alt="Tracey logo">

      </div>
      <div class="d-flex align-items-start flex-grow-1">
        <div class="fw-semibold title-wrapper line-height-1">
          {{t('policy.consent.title')}}
        </div>
      </div>
      <div class="pe-20 d-flex">
        <button type="button" class="btn-close" aria-label="Close" (click)="onDismissClick()"></button>
      </div>
    </div>
    <div class="body-wrapper">
      <div class="chapter mt-1">
        <p class="fw-medium fs-28">
          {{t('policy.consent.personal.data.protection')}}
          <a (click)="goToPersonalDataProtection()">
            {{t("policy.notice.on.personal.data.protection")}}
          </a>
        </p>
        <p class="fw-medium fs-28">
          {{t('policy.consent.general.conditions')}}
          <a (click)="goToGeneralConditions()">
            {{t("policy.general.conditions")}}
          </a>
        </p>
      </div>

      <div class="chapter mt-3">
        @if (isProfile) {
          <p [innerHTML]="t('policy.consent.profile.chapter.1')"></p>
          <ul class="pt-2">
            <li><p [innerHTML]="t('policy.consent.profile.chapter.1.1')"></p></li>
            <li><p [innerHTML]="t('policy.consent.profile.chapter.1.2')"></p></li>
            <li><p [innerHTML]="t('policy.consent.profile.chapter.1.3')"></p></li>
          </ul>

          <p [innerHTML]="t('policy.consent.profile.chapter.1.4')"></p><a (click)="goToPersonalDataProtection()">{{
              t("policy.notice.on.personal.data.protection")
            }}</a>


          <p class="pt-3" [innerHTML]="t('policy.consent.profile.chapter.2')"></p><a
            (click)="goToPersonalDataProtection()">
            {{t("policy.notice.on.personal.data.protection")}}
          </a>
        } @else {
          <p [innerHTML]="t('policy.consent.platform.chapter.1')"></p>
          <ul class="pt-2">
            <li><p [innerHTML]="t('policy.consent.platform.chapter.1.1')"></p></li>
            <li><p [innerHTML]="t('policy.consent.platform.chapter.1.2')"></p></li>
          </ul>

          <p class="pt-3" [innerHTML]="t('policy.consent.platform.chapter.2')"></p>
          <ul class="pt-2">
            <li><p [innerHTML]="t('policy.consent.platform.chapter.2.1')"></p></li>
            <li><p [innerHTML]="t('policy.consent.platform.chapter.2.2')"></p></li>
          </ul>
        }

        <p class="pt-4">
          <b>{{t('policy.consent.chapter.4.1')}}</b>
          {{t('policy.consent.chapter.4.2')}}
          <a href="mailto: {{environment.contactMail}}">{{environment.contactMail}}</a>.
          {{t('policy.consent.chapter.4.3')}}
          <a href="mailto: {{environment.contactMail}}">{{environment.contactMail}}</a>
        </p>

        <p class="pt-4">
          {{t('policy.consent.chapter.5.1')}}
          <a href="mailto: {{environment.contactMail}}">{{environment.contactMail}}</a>
        </p>
      </div>
    </div>

    <div class="d-flex justify-content-center align-items-center pb-40-48">
      <div class="d-flex">
        <app-rounded-button [label]="t('app.common.accept')" (onClick)="onConfirmClick()"
                            [btnClass]="'btn-primary-red text-uppercase'"></app-rounded-button>
      </div>
    </div>
  </div>

</ng-container>
